<template>
  <div class="addMessageType">
    <!--详情-->
    <el-dialog
      :title="$t('messageType.form.messageTempDetailTitle')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="500px"
    >
      <el-form label-width="auto" :model="addList" ref="addList" :label-position="'right'">
        <el-form-item :label="$t('messageType.form.type')">
          <el-input v-model="addList.messageTypeName" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label="$t('messageType.form.title')">
          <el-input v-model="addList.title" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label="$t('messageType.form.content')">
          <el-input v-model="addList.content" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label="$t('messageType.form.redirectUrl')">
          <el-input v-model="addList.redirectUrl" :disabled="true"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  import API from '@/api/messageCenter/messageTemp.js';
  export default {
    name: 'detailMessageTemp',
    data() {
      return {
        dialogAdd: false,
        addList: {
          messageTypeId: '',
          title: '',
          content: '',
          redirectUrl: '',
        },
      };
    },
    methods: {
      openDialog(flag, row) {
        if (this.$refs['addList']) {
          this.$refs['addList'].resetFields();
        }
        this.dialogAdd = flag;
        this.getDetail(row.id);
      },
      getDetail(id) {
        this.$axios.get(API.MESSAGE_TEMP_DETAIL_API + id).then((res) => {
          if (0 != res.data.code) {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'error',
            });
          } else {
            this.$emit('getData');
            this.addList = res.data.data;
          }
        });
      },
    },
  };
</script>
